import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CategoryProductListLoading from '~/components/organisms/Category/Loading/CategoryProductListLoading.vue';
export default {
  name: 'CategoryLoading',
  components: {
    CategoryProductListLoading: CategoryProductListLoading
  },
  props: {
    search: {
      type: Boolean,
      default: false
    }
  }
};